import OrdersLogPageView from "./OrdersLogPageView";

function OrdersLogPage() {
  return <OrdersLogPageView />;
}

export default OrdersLogPage;
